import { createApp } from './app'
const env = require('../env.json');

const { app, router, store } = createApp();

router.onReady(() => {
  if (window.__INITIAL_STATE__) {
    // заменяет стейт на тот, что пришел с сервера
    store.replaceState(window.__INITIAL_STATE__);
  }

  store.commit('setApi', env.api)

  app.$mount('#app');
});



// WEBPACK FOOTER //
// ./src/entry-client.js